import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { PermissionControlName } from '../../../enums/organisation/PermissionControlName.js';
import { PermissionControlValue } from '../../../enums/organisation/PermissionControlValue.js';
export class PermissionControl extends BaseMessage {
    name;
    value;
}
__decorate([
    Field.enum({
        enum: PermissionControlName,
        description: 'Name of the permission',
        example: PermissionControlName.OFFLINE_CONTROLS,
        required: true,
    }),
    __metadata("design:type", String)
], PermissionControl.prototype, "name", void 0);
__decorate([
    Field.enum({
        enum: PermissionControlValue,
        description: 'Level of the permission',
        example: PermissionControlValue.ONE,
        required: true,
    }),
    __metadata("design:type", String)
], PermissionControl.prototype, "value", void 0);
//# sourceMappingURL=PermissionControl.js.map